import currency from "currency.js";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { useEffect, useState } from "react";
import { CloseButton, Form, Table } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { services } from "../../config";
import { useAuth } from "../../hooks/useAuth";
import useDebounce from "../../utils/hooks";
import { queryActions } from "../../utils/reactQueryActions";
import "./../../assets/scss/scoped/items-table.scoped.scss";
import queryString from "query-string";
import ReactPaginate from "react-paginate";
import {
  fetchActionsUtil,
  itemPickerSourceOptions,
  paginationOptions,
} from "../../utils/helpers";
import Select from "react-select";
import { useFormik } from "formik";
import { isEmpty, values } from "lodash";
import { useStoreState } from "easy-peasy";
import WarehousePicker from "../warehouse/WarehousePicker";
import { toast } from "react-toastify";
import CreatableSelect from "react-select/creatable";

////// =
const itemsStatusOptions = [
  { label: "All", value: "" },
  { label: "Unprocessed", value: "Unprocessed" },
  { label: "Processed", value: "Processed" },
];

////// =
export default function OnlineStoreMenuItems({
  handleSelectedItem,
  hideItemsNotInStock = false,
  model = "Items",
  type = "",
  getItemFrom = "Items",
  withVendorUnitCost = false,
  Vendor_ID = "",
  defaultSort,
  ItemStatus = "",
  serialNumbers,
  mustFind = [],
  searchString = "",
  hideSearchBar = false,
  hasWarehousePicker = false,
  Item_Type = "",
}) {
  ////// =
  const generalSettings = useStoreState((state) => state?.generalSettings);
  const { backendUrl } = useAuth();
  const [itemsOptions] = useState(itemPickerSourceOptions);
  const [items, setItems] = useState([]);

  ////// =
  const [queryParams, setQueryParams] = useState({
    page: 1,
    limit: 100,
    q: searchString,
    model,
    getItemFrom,
    withVendorUnitCost,
    Vendor_ID,
    ItemStatus: generalSettings?.itemStatusSettings ? ItemStatus : null,
    ...(defaultSort ? { sort: defaultSort } : {}),
    mustFind: mustFind.map((el) => el).join(","),
    isRemoved: "Not Sold",
    includeServiceItems: "Inventory",
  });

  ////// =
  const debouncedqueryParams = useDebounce(queryParams, 500);
  const debouncedSearchString = useDebounce(searchString, 500);

  ////// =
  useEffect(() => {
    setQueryParams({ ...queryParams, q: debouncedSearchString });
  }, [debouncedSearchString]);

  ////// =
  const getItems = async (debouncedqueryParams) => {
    let apiUrl = `${backendUrl}/api/items`;

    // if warehouse is selected
    if (debouncedqueryParams?.W_ID) {
      if (["Assets", "non-stock"].includes(debouncedqueryParams.W_Category)) {
        apiUrl = `${backendUrl}/api/warehouse/assets/${
          debouncedqueryParams.W_ID
        }`;
      } else {
        apiUrl = `${backendUrl}/api/warehouse/items/${
          debouncedqueryParams.W_ID
        }`;
      }
    }

    // I DO NOT THINK WAREHOUSE HAS ITEM_TYPE, it may be empty for old records
    if (Item_Type && !debouncedqueryParams?.W_ID) {
      debouncedqueryParams.Item_Type = Item_Type;
    }

    apiUrl = `${apiUrl}?${queryString.stringify(debouncedqueryParams)}`;

    let response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();

    // if warehouse is selected, the items are in data.warehouses
    // Poor naming on the backend
    if (debouncedqueryParams?.W_ID) {
      data.items = data.warehouses;
    }

    data.topCategory = data?.topCategory
      ? data.topCategory.map((category) => ({
          value: category.topCategory,
          label: category.topCategory,
        }))
      : [];

    return data;
  };

  ////// =
  const { data = { items: [] }, refetch } = useQuery(
    [queryActions.GET_ITEMS, debouncedqueryParams],
    () =>
      serialNumbers
        ? fetchActionsUtil(
            `${backendUrl}/api/items/all-serial-item?&${queryString.stringify(
              queryParams
            )}`
          )
        : getItems(debouncedqueryParams),
    {
      enabled: true,
      keepPreviousData: true,
    }
  );

  const handleShowItemOnOnlineStore = useMutation(
    (payload) =>
      fetchActionsUtil(
        `${backendUrl}/api/items/toggle-online-store-menu-item`,
        "POST",
        "",
        payload
      ),
    {
      onSuccess: (data) => {
        refetch();
        // toast.success(data.message);
      },
      onError: (error) => {
        toast.error(error.message);
      },
    }
  );

  ////// =
  return (
    <div className="items-table-area rounded">
      <div className=" d-flex justify-content-between align-items-center p-1">
        <h6 className="h5 p-3 pb-1 m-0">Select Online Store Menu Items</h6>
        <CloseButton onClick={() => handleSelectedItem(false)} />
      </div>

      <div className="search-area m-3 gap-3">
        {!hideSearchBar && (
          <>
            <MagnifyIcon />
            <input
              className="form-control search-input"
              name="q"
              value={queryParams.q}
              onChange={(e) =>
                setQueryParams({
                  ...queryParams,
                  page: 1,
                  [e.target.name]: e.target.value,
                })
              }
              placeholder="Search item..."
              autoFocus
              autoComplete="off"
              type={"text"}
            />
          </>
        )}
        {!isEmpty(type) && (
          <div className={hideSearchBar ? "w-100" : "w-50"}>
            <Select
              placeholder="Select..."
              options={itemsOptions}
              value={itemsOptions.find(
                (el) => el.value === queryParams.getItemFrom
              )}
              onChange={(selection) =>
                setQueryParams({
                  ...queryParams,
                  getItemFrom: selection?.value,
                })
              }
            />
          </div>
        )}
      </div>

      {hasWarehousePicker && (
        <div className="px-3 mb-3">
          <WarehousePicker
            value={queryParams.W_ID}
            onChange={(selected) => {
              setQueryParams({
                ...queryParams,
                W_ID: selected?.value,
                W_Category: selected?.W_Category,
                page: 1,
              });
            }}
            menuPosition="absolute"
          />
        </div>
      )}

      <div className="content">
        {serialNumbers ? (
          <Table borderless hover striped className="product-table">
            <thead className="sticky text-nowrap">
              <tr>
                <th scope="col">Serial Number</th>
                <th scope="col">Show on Menu</th>
                <th scope="col">Item Code</th>
                {/* <th scope="col">Item Name</th>
                <th scope="col">Unit Cost</th> */}
                {/* <th scope="col">Unit Price</th> */}
              </tr>
            </thead>
            <tbody>
              {data?.mustFindItems &&
                data?.mustFindItems
                  .filter((el) =>
                    hideItemsNotInStock
                      ? Number(el?.Items_Serial?.Quantity) > 0
                      : el
                  )
                  .map((el, index) => (
                    <tr
                      className="p-cursor correct"
                      key={index}
                      onClick={() => {
                        // console.log(el);

                        handleSelectedItem &&
                          handleSelectedItem({
                            ...el,
                            W_ID: el?.Warehouse,
                            W_Category: queryParams?.W_Category,
                          });
                      }}
                    >
                      <td>{el?.serialNum}</td>
                      <td>
                        <Form.Switch
                          onChange={(e) => {
                            if (el?.showOnOnlineStoreMenu) {
                              handleShowItemOnOnlineStore.mutate({
                                Bar_Code: el?.Bar_Code,
                                showOnOnlineStoreMenu: false,
                              });
                            } else {
                              handleShowItemOnOnlineStore.mutate({
                                Bar_Code: el?.Bar_Code,
                                showOnOnlineStoreMenu: true,
                              });
                            }
                          }}
                          checked={el?.showOnOnlineStoreMenu}
                        />
                      </td>
                      <td>{el?.Items_Serial?.Bar_Code}</td>
                      {/* <td title={el?.Items_Serial?.Quantity}>
                        {el?.Items_Serial?.Item_Name}
                      </td>
                      <td>
                        {currency(el?.Batch_Serial?.UnitCost, {
                          precision: 2,
                          symbol: "",
                        }).format()}
                      </td> */}
                    </tr>
                  ))}

              {data?.stockCounts &&
                data?.stockCounts
                  .filter((el) =>
                    hideItemsNotInStock
                      ? Number(el?.Items_Serial?.Quantity) > 0
                      : el
                  )
                  .map((el, index) => (
                    <tr
                      className="p-cursor"
                      key={index}
                      onClick={() => {
                        // console.log(el);

                        handleSelectedItem &&
                          handleSelectedItem({
                            ...el,
                            W_ID: el?.Warehouse,
                            W_Category: queryParams?.W_Category,
                          });
                      }}
                    >
                      <td>{el?.serialNum}</td>
                      <td>{el?.Items_Serial?.Bar_Code}</td>
                      <td title={el?.Items_Serial?.Quantity}>
                        {el?.Items_Serial?.Item_Name}
                      </td>
                      <td>
                        {currency(el?.Batch_Serial?.UnitCost, {
                          precision: 2,
                          symbol: "",
                        }).format()}
                      </td>
                      {/* <td>
                        {currency(el?.Items_Serial?.UnitPrice, {
                          precision: 2,
                          symbol: "",
                        }).format()}
                      </td> */}
                    </tr>
                  ))}
            </tbody>
          </Table>
        ) : (
          <Table borderless hover striped className="product-table">
            <thead className="sticky text-nowrap">
              <tr>
                <th scope="col">Show on Menu</th>
                {/* <th scope="col">Item Code</th> */}
                <th scope="col">Item Name</th>
                <th scope="col">Top Category</th>
                {/* <th scope="col">Unit Cost</th>
                <th scope="col">Unit Price</th> */}
              </tr>
            </thead>
            <tbody>
              {data.items &&
                data.items
                  .filter((el) =>
                    hideItemsNotInStock ? Number(el.Quantity) > 0 : el
                  )
                  .map((el, index) => (
                    <tr
                      className="p-cursor"
                      key={index}
                      onClick={() => {
                        // console.log(el, queryParams);
                        handleSelectedItem &&
                          handleSelectedItem({
                            ...el,
                            W_ID: el?.Warehouse,
                            W_Category: queryParams?.W_Category,
                          });
                      }}
                    >
                      <td>
                        <Form.Switch
                          onChange={(e) => {
                            if (el?.showOnOnlineStoreMenu) {
                              handleShowItemOnOnlineStore.mutate({
                                Bar_Code: el?.Bar_Code,
                                showOnOnlineStoreMenu: false,
                              });
                            } else {
                              handleShowItemOnOnlineStore.mutate({
                                Bar_Code: el?.Bar_Code,
                                showOnOnlineStoreMenu: true,
                              });
                            }
                          }}
                          checked={el?.showOnOnlineStoreMenu}
                        />
                      </td>
                      {/* <td>{el.Bar_Code}</td> */}
                      <td title={el?.Quantity}>{el.Item_Name}</td>

                      <CreatableSelect
                        classNamePrefix={`form-select`}
                        options={data?.topCategory || []}
                        onChange={({ value }) => {
                          // let itemsArr = items;
                          // const categoryText = items?.find(
                          //   (cat) => cat.topCategory === value
                          // );
                          // if (categoryText) {
                          // } else {
                          //   itemsArr = [...itemsArr, { topCategory: value }];

                          //   setItems(ite)
                          // }

                          handleShowItemOnOnlineStore.mutate({
                            topCategory: value,
                            showOnOnlineStoreMenu: el?.showOnOnlineStoreMenu,
                            Bar_Code: el?.Bar_Code,
                          });
                        }}
                        value={{
                          value: el?.topCategory,
                          label: el?.topCategory,
                        }}
                      />
                      {/* <td>
                        {currency(el.UnitCost, {
                          precision: 2,
                          symbol: "",
                        }).format()}
                      </td>
                      <td>
                        {currency(el.UnitPrice, {
                          precision: 2,
                          symbol: "",
                        }).format()}
                      </td> */}
                    </tr>
                  ))}
            </tbody>
          </Table>
        )}
      </div>

      <div className="d-flex justify-content-between px-3 my-3 align-items-center pagination">
        <p className="m-0">
          Showing {data?.startIndex + 1} to{" "}
          {data?.endIndex <= data?.count ? data?.endIndex : data?.count} of{" "}
          {data.count} entries
        </p>

        <ReactPaginate
          {...paginationOptions}
          pageCount={Math.ceil(data.count / queryParams.limit)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={0}
          onPageChange={({ selected }) => {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            setQueryParams({
              ...queryParams,
              page: selected + 1,
            });
          }}
          forcePage={queryParams.page - 1}
        />
      </div>
    </div>
  );
}
